import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1bc3c49c&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc3c49c')) {
      api.createRecord('1bc3c49c', component.options)
    } else {
      api.reload('1bc3c49c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1bc3c49c&", function () {
      api.rerender('1bc3c49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Themes/Index.vue"
export default component.exports